import React, { createContext, useContext, useState, useEffect } from 'react';

const ConsentContext = createContext({
  hasConsent: null,
  acceptConsent: () => {},
  rejectConsent: () => {},
  showBanner: true,
});

export const useConsent = () => {
  const context = useContext(ConsentContext);
  if (!context) {
    throw new Error('useConsent must be used within ConsentProvider');
  }
  return context;
};

export const ConsentProvider = ({ children }) => {
  const [hasConsent, setHasConsent] = useState(null);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a consent choice
    const storedConsent = localStorage.getItem('cookieConsent');
    if (storedConsent !== null) {
      setHasConsent(storedConsent === 'true');
      setShowBanner(false);
    } else {
      setShowBanner(true);
    }
  }, []);

  const acceptConsent = () => {
    localStorage.setItem('cookieConsent', 'true');
    setHasConsent(true);
    setShowBanner(false);
    // Trigger Google AdSense or analytics initialization here if needed
    if (window.gtag) {
      window.gtag('consent', 'update', {
        ad_storage: 'granted',
        analytics_storage: 'granted',
      });
    }
  };

  const rejectConsent = () => {
    localStorage.setItem('cookieConsent', 'false');
    setHasConsent(false);
    setShowBanner(false);
    // Deny consent for tracking
    if (window.gtag) {
      window.gtag('consent', 'update', {
        ad_storage: 'denied',
        analytics_storage: 'denied',
      });
    }
  };

  return (
    <ConsentContext.Provider value={{ hasConsent, acceptConsent, rejectConsent, showBanner }}>
      {children}
    </ConsentContext.Provider>
  );
};
